import { render, staticRenderFns } from "./DocumentsPaginateComponent.vue?vue&type=template&id=74f4d879"
import script from "./DocumentsPaginateComponent.js?vue&type=script&lang=js&external"
export * from "./DocumentsPaginateComponent.js?vue&type=script&lang=js&external"
import style0 from "./DocumentsPaginateComponent.vue?vue&type=style&index=0&id=74f4d879&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports